import React from 'react';
import ReactDOM from 'react-dom';

class VideoSingle extends React.Component{

	constructor(props){
		super(props);

		this.interval = null;

		this.canplaythrough = null;
		this.progress = null;
		this.timeupdate = null;
		this.ended = null;


		this.fps = 5;
		this.fpsInterval =  1000 / this.fps;
		this.then = 0;
		this.startTime = this.then;
		this.now=0;
		this.elapsed = 0;

		console.log();
	}
	playVideo(){
		this.refs.video.play();
	}

	pauseVideo(){
		this.refs.video.pause();
	}

	changeVolume(volume){
		console.log(volume);
		this.refs.video.volume = volume;
	}

	attachListeners(){
		//console.log('loadeddata');
		this.canplaythrough = ()=>this.props.canplaythrough();
		this.progress = ()=>this.props.progress(this.refs.video);
		
		this.refs.video.addEventListener('canplaythrough',this.canplaythrough,false);
		this.refs.video.addEventListener('progress',this.progress,false);

		if(!this.props.addHandler){
			this.timeupdate = ()=>this.props.timeupdate(this.refs.video);
			this.ended = ()=>this.props.ended();

			this.refs.video.addEventListener('timeupdate',this.timeupdate,false);
			this.refs.video.addEventListener('ended',this.ended,false);
		}

		if(this.props.muted == "true"){
			this.refs.video.muted = true;
			console.log(this.refs.video);
		}

		//console.log('all events attached');
		this.update = requestAnimationFrame(()=>this.loop());
		console.log('loop started');
	}
	
	componentDidMount(){
		
		this.refs.video.onloadstart = function(){
			
			this.attachListeners();
		}.bind(this);
   	
	}

	componentWillUnmount(){

		console.log('willunmount');
		this.refs.video.removeEventListener('canplaythrough', this.canplaythrough);
		this.refs.video.removeEventListener('progress', this.progress);
		if(!this.props.addHandler){
			this.refs.video.removeEventListener('timeupdate', this.timeupdate);
			this.refs.video.removeEventListener('ended', this.ended);
		}

		this.cancelAnimationFrame();
	}


	cancelAnimationFrame(){
		cancelAnimationFrame(this.update);
	}

	loop(){
		this.update = requestAnimationFrame(()=>this.loop());
    this.now = Date.now();
    this.elapsed = this.now - this.then;

    if (this.elapsed > this.fpsInterval) {

      this.then = this.now - (this.elapsed % this.fpsInterval);
			
			if (this.refs.video.readyState < this.refs.video.HAVE_FUTURE_DATA) {
		  	this.props.isCurrentlyLoading(this.refs.video);
		  }else{
		  	this.props.hasStoppedLoading(this.refs.video);
		  }
    }
	}

	render(){

		return (
				<video className={ this.props.state } poster="" playsInline ref="video">
					<source src={this.props.mp4src} type="video/mp4" />
					<source src={this.props.oggsrc} type="video/ogg" />
					<source src={this.props.webmsrc} type="video/webm" />
				</video>
		);
	}
}


export default VideoSingle;


// WEBPACK FOOTER //
// ./src/scripts/videoSingle.js